import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import AbcCurveReportForm from '@/components/Reports/PurchasesReports/AbcCurveReportForm';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useGeneratePurchaseAbcCurve } from '@/core/domain/NetReport/Purchase/Purchase.hooks';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import {
  PurchaseAbcCurveFormValues,
  PurchaseAbcCurveRequest,
} from '@/core/domain/NetReport/Purchase/Purchase.types';
import moment from 'moment';

function PurchasesAbcCurvePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<PurchaseAbcCurveFormValues>();

  const report = useReportGenerate();
  const mutation = useGeneratePurchaseAbcCurve();
  const { fileLoading, setFileLoading, setFileUnloading } = useFileLoading();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { initialDate, finalDate, companiesIds, ...values } =
        await form.validateFields();

      const obj: PurchaseAbcCurveRequest = {
        ...values,
        companiesIds: companiesIds && String(companiesIds),
        startDate: moment(initialDate).format('YYYY-MM-DD'),
        endDate: moment(finalDate).format('YYYY-MM-DD'),
      };

      const result = await mutation.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const handleView = () => {
    handleGenerateReport('REPORT_VIEW', (result) =>
      report.openFile({
        result,
        fileName: 'relatorio_curva_abc.pdf',
        fileType: 'application/pdf',
      }),
    );
  };

  const handlePdf = () => {
    handleGenerateReport('PDF', (result) =>
      report.downloadFile({
        result,
        fileName: 'relatorio_curva_abc.pdf',
      }),
    );
  };

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <AbcCurveReportForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}

export default PurchasesAbcCurvePage;
